import React, { useMemo } from "react"
import styled from "styled-components"

import SocialLink from "../../../utils/SocialLink"
import Reveal from "../../../utils/Reveal"

import Box from "../../../atoms/Box"
import Button from "../../../atoms/Button"
import Card from "../../../atoms/Card"
import Flex from "../../../atoms/Flex"
import ImageOrVideo from "../../../atoms/ImageOrVideo"
import StandardPadding from "../../../atoms/StandardPadding"

import Newsletter from "../../Newsletter"
import SectionTitle from "../../SectionTitle"

const StyledImageOrVideo = styled(ImageOrVideo)`
  .gatsby-image-wrapper {
    & div {
      ${props =>
        props.mediaPositioningNotFloating ? `padding-bottom: 31%;` : null};
    }
  }
`

export const getChildrenStyles = (
  {
    isMediaPositioningFloating,
    overlap,
    yOffsetOverlap,
    card,
    mediaPositioningOnMobile,
    mediaLocation,
  },
  layoutType,
  alignProp,
  mediaRatio,
  location,
  mediaPositioning,
  hasImageOrVideo
) => {
  let yOffsetOverlapPixels = Math.abs(yOffsetOverlap)
  yOffsetOverlapPixels =
    yOffsetOverlapPixels > 340 && layoutType === "stacked"
      ? 340
      : yOffsetOverlapPixels

  card = {
    ...card,
    useCard: overlap && !card?.useCard ? true : card?.useCard,
    theme: overlap && !card?.useCard ? "light" : card?.theme,
    bg: overlap && !card?.useCard ? 0 : card?.bg,
  }

  return {
    child1Style: {
      zIndex: overlap ? 15 : 10,
      paddingLeft:
        !isMediaPositioningFloating && location === "right" ? "0px" : null,
      alignSelf:
        mediaPositioning !== "floating" && !overlap
          ? "center"
          : alignProp === "center"
          ? "center"
          : `flex-${alignProp}`,
      width: layoutType === "adjacent" ? "100%" : "inherit",
      mb:
        hasImageOrVideo && overlap
          ? mediaPositioning === "floating" &&
            (layoutType === "stacked" || mediaPositioningOnMobile === "bottom")
            ? {
                _:
                  mediaPositioningOnMobile === "top"
                    ? 0
                    : yOffsetOverlap > 56
                    ? 56
                    : `${yOffsetOverlap * 0.25}px`,
                sm:
                  yOffsetOverlap > 56
                    ? `${56}px`
                    : location === "bottom" &&
                      mediaPositioningOnMobile === "bottom"
                    ? `${-yOffsetOverlapPixels * 0.15}px`
                    : mediaPositioningOnMobile === "top"
                    ? 0
                    : `${yOffsetOverlap * 0.7}px`,
                md:
                  yOffsetOverlap > 56
                    ? `${56}px`
                    : location === "top"
                    ? `${
                        yOffsetOverlap < 0
                          ? -yOffsetOverlapPixels
                          : yOffsetOverlapPixels
                      }px`
                    : null,
              }
            : !isMediaPositioningFloating
            ? {
                _:
                  mediaPositioningOnMobile === "top"
                    ? 0
                    : `${-yOffsetOverlapPixels * 0.15}px`,
                sm:
                  mediaPositioningOnMobile === "top"
                    ? 0
                    : `${-yOffsetOverlapPixels * 0.25}px`,
                md: yOffsetOverlap < 0 ? `${yOffsetOverlapPixels}px` : 0,
              }
            : null
          : location === "top" && (overlap || card)
          ? 7
          : 0,
      mt:
        hasImageOrVideo &&
        overlap &&
        (layoutType === "stacked" || layoutType === "adjacent")
          ? mediaPositioning === "floating"
            ? {
                _:
                  mediaPositioningOnMobile === "bottom"
                    ? 0
                    : yOffsetOverlap > 56
                    ? 56
                    : `${-yOffsetOverlapPixels * 0.25}px`,
                sm:
                  mediaPositioningOnMobile === "bottom"
                    ? 0
                    : yOffsetOverlap > 56
                    ? 56
                    : `${yOffsetOverlap * 0.5}px`,
                md: `${
                  layoutType === "adjacent" && yOffsetOverlap > 0
                    ? yOffsetOverlapPixels //this margin needs to be positive to prevent card oveflowing to sectionTItle
                    : location === "top" ||
                      (layoutType === "adjacent" && yOffsetOverlap <= 0)
                    ? 0
                    : yOffsetOverlap < -56
                    ? 56 //limitting margin between image and text to at most 56 pixels
                    : yOffsetOverlap < 0
                    ? yOffsetOverlapPixels
                    : -yOffsetOverlapPixels
                }px`,
              }
            : !isMediaPositioningFloating
            ? {
                _:
                  mediaPositioningOnMobile === "bottom"
                    ? 0
                    : yOffsetOverlap > 56
                    ? -56
                    : `${-yOffsetOverlapPixels * 0.25}px`, // overlaping both element on mobile
                sm:
                  mediaPositioningOnMobile === "top"
                    ? `${-yOffsetOverlapPixels * 0.25}px`
                    : 0, //fit and half fit layout turns into a stack layout on mobile
                md: yOffsetOverlap > 0 ? `${yOffsetOverlapPixels * 0.25}px` : 0, // margin needs to be position on desktop layout to prevent overflow
                lg: yOffsetOverlap > 0 ? `${yOffsetOverlapPixels}px` : 0, // margin needs to be position on desktop layout to prevent overflow
              }
            : null
          : location === "bottom" && (overlap || card)
          ? 7 //restoring padding for standard layout styles
          : hasImageOrVideo &&
            overlap &&
            mediaPositioningOnMobile === "top" &&
            mediaPositioning === "floating"
          ? // &&
            // stackedLayout //maybe this is not needed
            {
              _:
                yOffsetOverlap > 56 && location === "top"
                  ? 7
                  : yOffsetOverlap < -56 && location === "bottom"
                  ? -7
                  : "inherit",
              md: "inherit",
            }
          : 0,
      //margin top and margin bottom overlap/offset image and text when overlap feature is turned on
      minWidth:
        hasImageOrVideo && mediaRatio > 50 && !isMediaPositioningFloating
          ? { _: "100%", md: "0%" }
          : null,
      flex:
        hasImageOrVideo && overlap && !isMediaPositioningFloating && mediaRatio
          ? Math.abs(1 - (mediaRatio - 5) / 100)
          : 1, //0.65 appr 60% and 0.45 appr 70%
    },
    child2Style: {
      zIndex: 12,
      alignSelf:
        mediaPositioning === "floating"
          ? { _: overlap ? "end" : "center", md: alignProp }
          : mediaPositioning === "fit"
          ? { _: "center", lg: "stretch" }
          : { _: "center", lg: "auto" },
      width: "100%",
      mt:
        hasImageOrVideo &&
        overlap &&
        layoutType === "adjacent" &&
        mediaPositioning === "floating" &&
        yOffsetOverlap < 0
          ? {
              _: layoutType === "adjacent" ? 0 : `${yOffsetOverlapPixels}px`,
              md: `${yOffsetOverlapPixels}px`,
            }
          : null,
      mr:
        overlap && mediaPositioning === "floating"
          ? {
              _: mediaLocation === "right" ? -5 : 5,
              md: 0,
            }
          : null,
    },
  }
}

export const getStandardPaddingProps = (
  { overlap, text, isMediaPositioningFloating, mediaLocation, xOffsetOverlap },
  hasImageOrVideo,
  layoutType,
  location,
  mediaPositioning
) => {
  const shouldDisableXOffset =
    text?.titleMaxWidth === "fullWidth" && layoutType === "stacked"
      ? true
      : false // disabling x-offset to prevent x-axis cut off

  xOffsetOverlap =
    layoutType === "stacked"
      ? (text?.titleMaxWidth === "fullWidth" ||
          text?.titleMaxWidth === "wide") &&
        xOffsetOverlap >= 200
        ? 200
        : xOffsetOverlap >= 400
        ? 400
        : xOffsetOverlap <= -400
        ? -400
        : xOffsetOverlap
      : xOffsetOverlap //limitting xOffesetOverlap based on layout settings

  return {
    verticalPadding: "custom",
    px: overlap
      ? 0
      : mediaPositioning === "fitToHeight"
      ? null
      : mediaPositioning === "fit"
      ? { _: 5, lg: 7, xl: 0 }
      : { _: 5, md: 7, lg: 0 },
    py: layoutType === "stacked" ? { _: 0, md: 5 } : null,
    pl:
      mediaPositioning === "fitToHeight" && location === "left"
        ? { _: 5, lg: 7, xl: 4 }
        : mediaPositioning === "fitToHeight"
        ? { _: 5, lg: 7 }
        : null,
    pr:
      mediaPositioning === "fitToHeight" && location === "right"
        ? { _: 5, lg: 7, xl: 4 }
        : mediaPositioning === "fitToHeight"
        ? { _: 5, lg: 7 }
        : null,
    position: "relative",
    zIndex: 10,
    width: "100%",
    height: "100%",
    left:
      hasImageOrVideo && overlap && !shouldDisableXOffset
        ? location === "left" && !isMediaPositioningFloating
          ? {
              _: mediaLocation === "left" ? `24px` : `-24px`,
              md: `${xOffsetOverlap - 56}px`,
            }
          : location === "left" && mediaPositioning === "floating"
          ? {
              _: mediaLocation === "left" ? `24px` : `-24px`,
              md: `${xOffsetOverlap}px`,
            }
          : location === "right" && !isMediaPositioningFloating
          ? {
              _: mediaLocation === "left" ? `24px` : `-24px`,
              md: `-${Math.abs(xOffsetOverlap + 270)}px`,
            }
          : (location === "right" && mediaPositioning === "floating") ||
            layoutType === "stacked"
          ? {
              _: mediaLocation === "left" ? `24px` : `-24px`,
              sm: `-${Math.abs(xOffsetOverlap * 0.1)}px`,
              md: `-${Math.abs(xOffsetOverlap * 0.2)}px`,
              lg: `-${Math.abs(xOffsetOverlap * 0.45)}px`,
              xl: `-${Math.abs(xOffsetOverlap)}px`,
            } // using pixel amt as default values here since spacing constant values from SS did not work
          : null
        : null,
  }
}

export const renderSectionTitle = ({
  sectionTitle,
  isMediaPositioningFloating,
}) => {
  if (!sectionTitle) return null

  return (
    <Reveal>
      <StandardPadding
        px={null}
        py={null}
        pt={!isMediaPositioningFloating ? { _: 5, lg: 7, xl: 8 } : null}
        pb={0}
      >
        <SectionTitle {...sectionTitle} maxWidth={42} />
      </StandardPadding>
    </Reveal>
  )
}

export const renderButtons = ({ button, button2, modal, text, location }) => {
  // if (!text) return null

  if (!button && !button2) return null

  if (button && button2 && modal?.size?.sizeSelections === "sm") {
    return (
      <Flex
        flexDirection="column"
        justifyContent={{ _: "space-evenly" }}
        alignItems="flex-end"
        width={{ _: "100%", md: "70%" }}
        flexWrap="wrap"
      >
        <Button
          aria-label="CTA button 1"
          mb={location === "bottom" ? 6 : 0}
          {...button}
        />
        <Button
          aria-label="CTA button 2"
          mb={location === "bottom" ? 6 : 0}
          {...button2}
        />
      </Flex>
    )
  }

  const buttons = []
  if (button) {
    buttons.push(
      <Button
        aria-label="CTA button 1"
        mt={5}
        mr={{ _: 0, md: button2 ? 5 : 0 }}
        mb={location === "bottom" ? 6 : 0}
        {...button}
      />
    )
  }

  if (button2) {
    buttons.push(
      <Button
        aria-label="CTA button 2"
        mt={5}
        mb={location === "bottom" ? 6 : 0}
        {...button2}
      />
    )
  }

  return (
    <Flex
      flexDirection={{ _: "column", md: "row" }}
      justifyContent={text?.align === "center" ? "center" : "flex-start"}
      alignItems={text?.align === "center" ? "center" : "flex-start"} //needed for mobile alignment
    >
      {buttons}
    </Flex>
  )
}

export const renderNewsletter = ({ useNewsletter, newsletter }) => {
  if (!useNewsletter) return null

  return (
    <Box mt={5}>
      <Newsletter justify={"start"} {...newsletter} />
    </Box>
  )
}

export const hasImageOrVideo = props => {
  return (
    (props.imageOrVideo?.isVideoSelected &&
      (props.imageOrVideo?.videoURL ||
        props.imageOrVideo?.mobileVideoURL ||
        props.imageOrVideo?.videoImageFallback)) ||
    props.imageOrVideo?.desktopImage ||
    props.imageOrVideo?.mobileImage
  )
}

export const renderImageOrVideo = (
  {
    imageOrVideo,
    isMediaPositioningFloating,
    mediaLocation,
    overlap,
    customPadding,
    mediaPositioningOnMobile,
  },
  location,
  layoutType,
  mediaPositioning
) => {
  if (!imageOrVideo) return null

  if (!customPadding) {
    customPadding = {
      _: 7,
      lg: null,
    }
  }

  const imageOrVideoStyles = !isMediaPositioningFloating
    ? {
        width: "100%",
        height: "100%",
        iframe: {
          maxWidth: "100%",
          maxHeight: "100%",
        },
        object: {
          maxWidth: "100%",
          maxHeight: "100%",
        },
        embed: {
          maxWidth: "100%",
          maxHeight: "100%",
        },
      }
    : {}

  return (
    <Box
      position="relative"
      width="100%"
      display="flex"
      justifyContent={
        (!isMediaPositioningFloating && location === "right") ||
        (overlap && layoutType === "stacked" && mediaLocation === "right")
          ? "flex-end"
          : (!isMediaPositioningFloating && location === "left") ||
            (overlap && layoutType === "stacked")
          ? "flex-start"
          : "center"
      }
      height={
        mediaPositioning === "fit" || mediaPositioning === "fitToHeight"
          ? "100%"
          : "auto"
      }
      pt={{
        _: location === "left" ? 5 : 0,
        sm:
          !isMediaPositioningFloating &&
          mediaPositioningOnMobile === "top" &&
          !overlap
            ? customPadding._
            : null,
        md: "inherit",
      }} // adds padding at mobile breakpoint since there is no standard padding when mediaPositioningNotFloating
      pb={{
        _: location === "left" ? 0 : 5,
        sm:
          !isMediaPositioningFloating && mediaPositioningOnMobile === "bottom"
            ? customPadding._
            : null,
        md: "inherit",
      }} // adds padding at mobile breakpoint since there is no standard padding when mediaPositioningNotFloating
      // {...imageOrVideoBoxStyles}
    >
      <Box
        position="relative"
        height="100%"
        width="100%"
        maxWidth={!isMediaPositioningFloating ? "100%" : 44}
        // minHeight={{ _: "100%", sm: "60vh" }}
      >
        <Reveal height="100%" width="100%">
          <StyledImageOrVideo
            {...imageOrVideo}
            videoProps={{
              ...imageOrVideo.videoProps,
              ...imageOrVideoStyles,
            }}
            imageStyles={imageOrVideoStyles}
            mediaPositioningNotFloating={!isMediaPositioningFloating && overlap}
          />
        </Reveal>
      </Box>
    </Box>
  )
}

export const getLocation = ({ imageTextLocation, location }) => {
  return imageTextLocation || location
}

export const getLayoutType = location => {
  if (location === "right" || location === "left") return "adjacent"

  if (location === "bottom" || location === "top") return "stacked"
}

export const getAlignProp = (
  { alignProp, imageTextAlign, overlap },
  layoutType,
  mediaPositioning
) => {
  const result =
    overlap && layoutType === "stacked"
      ? "end"
      : overlap && layoutType === "adjacent" && mediaPositioning !== "floating"
      ? "center"
      : overlap && layoutType === "adjacent"
      ? "start"
      : imageTextAlign || alignProp //setting align setting depending on layout when overlap is turned on

  return result
}

export const getMediaRatio = ({ mediaRatio }) => {
  return mediaRatio === null ? 50 : mediaRatio
}

export const getMarginBtwChilds = ({
  overlap,
  isMediaPositioningFloating,
  card,
}) => {
  if (!overlap) return 0

  return overlap && !isMediaPositioningFloating && card.useCard
    ? 10
    : !isMediaPositioningFloating && overlap
    ? 0
    : 7
}

export const renderCard = (
  { text, card, isMediaPositioningFloating, overlap },
  hasImageOrVideo,
  mediaRatio,
  layoutType,
  renderButtons,
  renderNewsletter,
  renderSocials,
  mediaPositioning
) => {
  if (!text) return null

  return (
    <Card
      className="card"
      p={card?.useCard ? 7 : null}
      width={
        hasImageOrVideo && overlap && layoutType === "adjacent"
          ? overlap && mediaPositioning === "floating"
            ? "100%"
            : !isMediaPositioningFloating
            ? { _: "100%", md: `${135 + mediaRatio}%` }
            : { _: "100%", md: `${210 + mediaRatio}%` }
          : null
      }
      height="100%"
      {...card}
    >
      <Box
        width={!isMediaPositioningFloating ? "100%" : "inherit"}
        height="100%"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        maxWidth={
          layoutType === "stacked" && text?.titleMaxWidth === "fullWidth"
            ? "100%"
            : layoutType === "stacked" && text?.titleMaxWidth === "wide"
            ? { _: "100%", md: 45, lg: 56 }
            : null
        }
        py={layoutType === "adjacent" ? { _: 2, md: 5 } : null}
        px={{ _: 0, md: 5 }}
      >
        <SectionTitle {...text} />
        {renderButtons}
        {renderNewsletter}
        {renderSocials}
      </Box>
    </Card>
  )
}

export const renderSocials = ({ socialLinks, socialLinkStyles, text }) => {
  if (socialLinks?.length === 0 || socialLinks === undefined) return null

  const socialStyles =
    socialLinkStyles === undefined || socialLinkStyles === null
      ? {
          color: "primary",
          theme: "highlight",
          bg: 3,
          iconStyle: "solid",
        }
      : socialLinkStyles

  return (
    <Box className="social" mt={5} mb={4} textAlign={text?.align}>
      {socialLinks?.map(socialLink => {
        return (
          <SocialLink {...socialLink} {...socialStyles} mr={5} mt={2} mb={3} />
        )
      })}
    </Box>
  )
}

export const getMediaPositioning = ({ mediaPositioning }) => {
  return mediaPositioning === null ? "floating" : mediaPositioning
}

export const useMemoizedProps = props => {
  const storage = {
    childrenStyles: useMemo(
      () =>
        getChildrenStyles(
          props,
          getLayoutType(getLocation(props)),
          getAlignProp(props, getLayoutType(getLocation(props))),
          getMediaRatio(props),
          getLocation(props),
          getMediaPositioning(props),
          hasImageOrVideo(props)
        ),
      [
        props.isMediaPositioningFloating,
        props.mediaPositioningOnMobile,
        props.location,
        props.mediaLocation,
        props.alignProp,
        props.imageTextAlign,
        props.mediaPositioning,
        props.overlap,
        props.yOffsetOverlap,
        props.card,
        props.mediaRatio,
        props.imageTextLocation,
        props.imageOrVideo,
      ]
    ),
    standardPaddingProps: useMemo(
      () =>
        getStandardPaddingProps(
          props,
          hasImageOrVideo(props),
          getLayoutType(getLocation(props)),
          getLocation(props),
          getMediaPositioning(props)
        ),
      [
        props.location,
        props.mediaPositioning,
        props.overlap,
        props.xOffsetOverlap,
        props.text,
        props.isMediaPositioningFloating,
        props.mediaLocation,
        props.layoutType,
      ]
    ),
    renderSectionTitle: useMemo(() => renderSectionTitle(props), [
      props.sectionTitle,
    ]),
    renderButtons: useMemo(() => renderButtons(props), [
      props.button,
      props.button2,
      props.modal?.size?.sizeSelections,
      props.openModalSectionById,
      props.text,
      props.card,
      props.isMediaPositioningFloating,
      props.layoutType,
      props.location,
    ]),
    renderNewsletter: useMemo(() => renderNewsletter(props), [
      props.useNewsletter,
      props.newsLetter,
    ]),
    hasImageOrVideo: useMemo(() => hasImageOrVideo(props), [
      props.imageOrVideo,
    ]),
    renderImageOrVideo: useMemo(
      () =>
        renderImageOrVideo(
          props,
          getLocation(props),
          getLayoutType(getLocation(props)),
          getMediaPositioning(props)
        ),
      [
        props.imageOrVideo,
        props.isMediaPositioningFloating,
        props.mediaLocation,
        props.overlap,
        props.customPadding,
        props.imageTextLocation,
        props.location,
        props.mediaPositioning,
      ]
    ),
    location: useMemo(() => getLocation(props), [
      props.imageTextLocation,
      props.location,
    ]),
    layoutType: useMemo(() => getLayoutType(getLocation(props)), [
      props.imageTextLocation,
      props.location,
    ]),
    align: useMemo(
      () =>
        getAlignProp(
          props,
          getLayoutType(getLocation(props)),
          getMediaPositioning(props)
        ),
      [props.imageTextLocation, props.location, props.alignProp]
    ),
    mediaRatio: useMemo(() => getMediaRatio(props), [
      props.imageTextLocation,
      props.location,
    ]),
    marginBtwChilds: useMemo(() => getMarginBtwChilds(props), [
      props.isMediaPositioningFloating,
      props.overlap,
      props.card,
    ]),
    renderCard: useMemo(
      () =>
        renderCard(
          props,
          hasImageOrVideo(props),
          getMediaRatio(props),
          getLayoutType(getLocation(props)),
          renderButtons(props),
          renderNewsletter(props),
          renderSocials(props),
          getMediaPositioning(props)
        ),
      [
        props.text,
        props.card,
        props.isMediaPositioningFloating,
        props.overlap,
        props.mediaPositioning,
        props.imageOrVideo,
        props.imageTextLocation,
        props.location,
        props.button,
        props.button2,
        props.modal?.size?.sizeSelections,
        props.openModalSectionById,
        props.useNewsletter,
        props.newsLetter,
        props.socialLinks,
        props.socialLinkStyles,
      ]
    ),
    renderSocials: useMemo(() => renderSocials(props), [
      props.socialLinks,
      props.socialLinkStyles,
    ]),
    mediaPositioning: useMemo(() => getMediaPositioning(props), [
      props.mediaPositioning,
    ]),
  }

  return Object.keys(storage).reduce((result, field) => {
    result[field] = storage[field]
    return result
  }, {})
}
